import { render, staticRenderFns } from "./DistributorIcon.vue?vue&type=template&id=465896ce&"
import script from "./DistributorIcon.vue?vue&type=script&lang=js&"
export * from "./DistributorIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports